
import {Component, Prop, Vue} from "vue-property-decorator";
import {MdbsCore} from "@/api/tsclient";
import IQueryShortDto = MdbsCore.IQueryShortDto;
import IQueryAnswerDto = MdbsCore.IQueryAnswerDto;
import {queryModule} from "@/store";
import IQueryAcceptDto = MdbsCore.IQueryAcceptDto;
import IQueryRevokeDto = MdbsCore.IQueryRevokeDto;
import IQuerySolveDto = MdbsCore.IQuerySolveDto;
import {deepCopy} from "@/auxillary";
import QueryTypeDefinitionDto = MdbsCore.QueryTypeDefinitionDto;
import QueryAnswerDialog from "@/components/query/dialogs/QueryAnswerDialog.vue";
import IQueryEditDto = MdbsCore.IQueryEditDto;
import QueriesCountIcon from "@/components/query/icons/QueriesCountIcon.vue";
import IQueryDeferDto = MdbsCore.IQueryDeferDto;
import QueryAnswerMenuItem from "@/components/query/menu/QueryAnswerMenuItem.vue";
import IQueryListResponse = MdbsCore.IQueryListResponse;

@Component({
  name: 'QueriesMenu',
  components: {QueriesCountIcon, QueryAnswerMenuItem, QueryAnswerDialog},
})
export default class QueriesMenu extends Vue {

  @Prop({required: true})
  private queryListResponse: IQueryListResponse;
  @Prop({required: true})
  private queryTypeDefinitions: Array<QueryTypeDefinitionDto>;
  @Prop({required: true})
  private referenceId: string;
  @Prop({required: true})
  private referenceType: string;

  showAnswerQuery = false;
  selectedQuery: IQueryShortDto | null = null;

  get queries() {
    return this.queryListResponse.items ?? [];
  }

  queryTypeDefinition(query: IQueryShortDto): QueryTypeDefinitionDto | undefined {
    if (!query)
      return undefined;
    return this.queryTypeDefinitions.find(qf => qf.definitionType == query.queryTypeDefinitionType);
  }

  handleAnswerQuery(query: IQueryShortDto) {
    this.selectedQuery = deepCopy(query);
    this.showAnswerQuery = true;
  }

  async handleEditQuery(queryEdit: IQueryEditDto) {
    await queryModule.editQuery(queryEdit);
    await queryModule.loadQueries({referenceType: this.referenceType, referenceId: this.referenceId});
    this.showAnswerQuery = false;
  }

  async handleSaveAnswerQuery(queryAnswer: IQueryAnswerDto) {
    await queryModule.answerQuery(queryAnswer);
    await queryModule.loadQueries({referenceType: this.referenceType, referenceId: this.referenceId});
    this.showAnswerQuery = false;
  }

  async handleRevokeAnswerQuery(queryRevoke: IQueryRevokeDto) {
    await queryModule.revokeQuery(queryRevoke);
    await queryModule.loadQueries({referenceType: this.referenceType, referenceId: this.referenceId});
    this.showAnswerQuery = false;
  }

  async handleAcceptAnswerQuery(queryAccept: IQueryAcceptDto) {
    await queryModule.acceptQuery(queryAccept);
    await queryModule.loadQueries({referenceType: this.referenceType, referenceId: this.referenceId});
    this.showAnswerQuery = false;
  }

  async handleSolveAnswerQuery(querySolve: IQuerySolveDto) {
    await queryModule.solveQuery(querySolve);
    await queryModule.loadQueries({referenceType: this.referenceType, referenceId: this.referenceId});
    this.showAnswerQuery = false;
  }

  async handleDeferAnswerQuery(queryDefer: IQueryDeferDto) {
    await queryModule.deferQuery(queryDefer);
    await queryModule.loadQueries({referenceType: this.referenceType, referenceId: this.referenceId});
    this.showAnswerQuery = false;
  }
}
